import type { CardType } from '@pushflow/types'
import { clsx } from 'clsx'
import { AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'
import { useEffect, useRef } from 'react'
import { userSettingsAtom } from '../../../../../store/atoms'
import { ECardType } from '../../../../../store/atoms/userSettings'
import { Card } from '../../../../atoms'
import { AnimatedCard } from '../../..'
import * as styles from './index.css'

export const CardBoard = (props: {
  cards: (CardType | 'null' | 'empty')[]
  shadow?: boolean
  className?: string
  isSnapshot?: boolean
  onNewCards?: (count: number) => void
}) => {
  const userSettings = useAtomValue(userSettingsAtom)
  const oldCards = useRef<typeof props.cards>()
  const className =
    userSettings.tableSettings.cardsType === ECardType.COLORED_CANVAS
      ? styles.cardWhiteShadow
      : props.shadow
        ? styles.cardShadow
        : undefined

  useEffect(() => {
    if (props.onNewCards) {
      const newCardsCount = oldCards.current
        ? props.cards.length - oldCards.current?.length
        : 0
      if (newCardsCount) {
        props.onNewCards(newCardsCount)
      }
    }
    oldCards.current = props.cards
  }, [props.cards])

  return (
    <div className={clsx(styles.cards, props.className)}>
      <AnimatePresence>
        {props.cards.map((card, index) =>
          card === 'empty' ? (
            <span key={index} />
          ) : props.isSnapshot ? (
            <Card
              value={card}
              key={index}
              cardBack={userSettings.tableSettings.cardsBack}
              theme={userSettings.tableSettings.cardsType}
              className={className}
            />
          ) : (
            <AnimatedCard
              key={index}
              animationType='slideDown'
              value={card}
              cardBack={userSettings.tableSettings.cardsBack}
              theme={userSettings.tableSettings.cardsType}
              className={className}
            />
          ),
        )}
      </AnimatePresence>
    </div>
  )
}
